import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading, Text } from '../../components/Typography/Typography';
import { Button } from '../../components/UI';
import styles from './UnauthorizedPage.module.scss';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleReturnToLogin = () => {
    navigate('/login');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Heading level={2}>Unauthorized</Heading>
        <Text size="base" className={styles.message}>
          Your session has expired or you are not authorized to access this page.
        </Text>
        <Button onClick={handleReturnToLogin} variant="primary">
          Return to Login
        </Button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
